import styled from 'styled-components';

export const ActionsPanel = styled.div`
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    background-color: transparent;
    min-height: 60px;
    height: 60px;

    @media screen and (max-width: 700px) {
        min-height: 40px;
        height: 40px;
    }
`